import { render, staticRenderFns } from "./VoucherCustomer.vue?vue&type=template&id=2534b298&"
import script from "./VoucherCustomer.vue?vue&type=script&lang=js&"
export * from "./VoucherCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports